function isNullOrWhitespace(value?: string | null): boolean {
    return value === null
        || value === undefined
        || value.trim().length === 0;
}

export const StringValidator = {
    isNullOrWhitespace,
}
